<mat-form-field class="w-100" [subscriptSizing]="hideMatHint ? 'dynamic' : 'fixed'">
    <mat-label>{{ field.name }}</mat-label>
    <input
        [formControl]="fc"
        [name]="field.name"
        [placeholder]="field.name"
        [matAutocomplete]="auto"
        matInput
        type="text" />
    <mat-error [control]="fc"></mat-error>
    <mat-autocomplete #auto="matAutocomplete">
        @for (complete of autocomplete | async; track complete) {
            <mat-option [value]="complete">{{ complete }}</mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
